import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { extractLanguageFromPath } from "../utils/languageRouting";

// Import translation files
import enTranslations from "./locales/en.json";
import itTranslations from "./locales/it.json";
import esTranslations from "./locales/es.json";
import frTranslations from "./locales/fr.json";
import deTranslations from "./locales/de.json";
import ptTranslations from "./locales/pt.json";
import ruTranslations from "./locales/ru.json";
import zhTranslations from "./locales/zh.json";
import jaTranslations from "./locales/ja.json";
import arTranslations from "./locales/ar.json";
import hiTranslations from "./locales/hi.json";
import koTranslations from "./locales/ko.json";
import nlTranslations from "./locales/nl.json";
import csTranslations from "./locales/cs.json";

const resources = {
  en: { translation: enTranslations },
  it: { translation: itTranslations },
  es: { translation: esTranslations },
  fr: { translation: frTranslations },
  de: { translation: deTranslations },
  pt: { translation: ptTranslations },
  ru: { translation: ruTranslations },
  zh: { translation: zhTranslations },
  ja: { translation: jaTranslations },
  ar: { translation: arTranslations },
  hi: { translation: hiTranslations },
  ko: { translation: koTranslations },
  nl: { translation: nlTranslations },
  cs: { translation: csTranslations },
};

// Custom path language detector
const pathLanguageDetector = {
  name: "path",
  lookup() {
    const pathname = window.location.pathname;
    const { language } = extractLanguageFromPath(pathname);
    return language || undefined;
  },
  cacheUserLanguage(lng: string) {
    // Cache is handled by localStorage detector
  }
};

i18n
  .use({
    type: "languageDetector",
    async: false,
    init: () => {},
    detect: pathLanguageDetector.lookup,
    cacheUserLanguage: pathLanguageDetector.cacheUserLanguage
  } as any)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    debug: false,
    
    detection: {
      // Priority: localStorage (user's choice) > path > navigator > htmlTag
      // This ensures when user presses back button, their last selected language persists
      order: ["localStorage", "path", "navigator", "htmlTag"],
      caches: ["localStorage"],
    },
    
    interpolation: {
      escapeValue: false,
    },
    
    // Normalize language codes (en-US, en-GB -> en)
    load: "languageOnly",
    
    // Ensure we only use our supported languages
    supportedLngs: ["en", "it", "es", "fr", "de", "pt", "ru", "zh", "ja", "ar", "hi", "ko", "nl", "cs"],
    nonExplicitSupportedLngs: true,
  });

export default i18n;

